import React from "react";
import { withTranslation } from "react-i18next";
import { ViewImage } from "./viewImage";

class ViewImageParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return <ViewImage {...this?.props} />;
    }
}

export default withTranslation('asset')(ViewImageParent);